import { render, staticRenderFns } from "./CouponApp.vue?vue&type=template&id=334265f4&"
import script from "./CouponApp.vue?vue&type=script&lang=js&"
export * from "./CouponApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports